<template>
  <v-container
    class="fill-height d-flex flex-column justify-center align-center text-center"
  >
    <v-card
      elevation="0"
      class="pa-8 rounded-lg"
      :class="$vuetify.theme.dark ? 'dark-card' : 'light-card'"
      max-width="500"
    >
      <v-icon
        size="90"
        color="#ff567f"
        class="mb-4"
      >
        mdi-shield-lock-outline
      </v-icon>

      <h1 class="font-weight-bold mb-3" style="font-size: 38px;">
        403 — Access Denied
      </h1>

      <p class="subtitle-1 mb-6">
        You don’t have permission to access this page.<br />
        Please contact your administrator if you believe this is a mistake.
      </p>

      <v-btn
        color="#0593DA"
        dark
        large
        class="px-10"
        @click="$router.push('/dashboard')"
      >
        Go to Dashboard
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Forbidden403",
};
</script>

<style scoped>
.light-card {
  background: #d1d8dd9d;
}

.dark-card {
  background: #1b283aa6;
}
</style>
